// Charge la base commune
import './common.js'

// Styles custom
import './scss/pages/blog'

// Scripts librairies
/* global Waypoint */
import 'waypoints/lib/jquery.waypoints.min.js'
import './js/libs/paginate/jquery.paginate.min.js'

// rafraîchissement
function r () {
  Waypoint.refreshAll()
}

// OwlCarousel
function getOwlCarousel () {
  import(/* webpackChunkName: "owl-carousel" */ './js/components/owl-carousel.js').then(() => {
    r()
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion des carousel
  const $f = $('div.owl-carousel')
  if ($f.length) {
    $f.waypoint(function () {
      getOwlCarousel()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // refresh waypoints au chargement d'une image
  $('.lazyload').on('lazyloaded', () => {
    r()
  })
  setTimeout(function () {
    r()
  }, 500)

  // jquery pajinate
  $('div.pajinate').each(function () {
    const t = $(this)
    const perPage = t.attr('data-pajinante-items-per-page') || 5
    const numLinks = t.attr('data-pajinante-num-links') || 5
    t.pajinate({
      items_per_page: parseInt(perPage),
      num_page_links_to_display: parseInt(numLinks),
      item_container_id: t.attr('data-pajinate-container') || '.pajinate-container',
      nav_panel_id: '.pajinate-nav ul',
      show_first_last: true,
      wrap_around: true,
      abort_on_small_lists: true,
      start_page: 0,
      nav_label_prev: '<i class="icon-angle-left"></i>',
      nav_label_next: '<i class="icon-angle-right"></i>',
      nav_label_first: '<i class="icon-angle-double-left"></i>',
      nav_label_last: '<i class="icon-angle-double-right"></i>'
    })
  })
})
